<template>
  <div>
    <ul class="breadcrumb">
      <li v-for="item in breadcrumb.items">
        <a
          class="link"
          @click="item.action?item.action():nothing"
          :href="item.path"
        >{{ item.title }}</a>
      </li>
      <li>{{ breadcrumb.title }}</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "breadcrumb",
  methods: {
    nothing() {}
  },
  props: {
    breadcrumb: {
      default: {
        title: "test",
        items: []
      }
    }
  }
};
</script>
<style scoped>
/* Style the list */
.breadcrumb {
  background-color: white;
}
ul.breadcrumb {
  padding: 10px 16px;
  list-style: none;
  max-width: 100vw;
}

/* Display list items side by side */
ul.breadcrumb li {
  display: inline;
  font-size: 18px;
}

/* Add a slash symbol (/) before/behind each list item */
ul.breadcrumb li + li:before {
  padding: 8px;
  content: "/\00a0";
}

/* Add a color to all links inside the list */
ul.breadcrumb li a {
  text-decoration: none;
}

/* Add a color on mouse-over */
ul.breadcrumb li a:hover {
  text-decoration: underline;
}

.darkBread > ul.breadcrumb li + li:before {
  padding: 8px;
  color: whitesmoke;
  content: "/\00a0";
}

/* Add a color to all links inside the list */
.darkBread > ul.breadcrumb li a {
  color: whitesmoke;
  text-decoration: none;
}

/* Add a color on mouse-over */
.darkBread > ul.breadcrumb li a:hover {
  color: whitesmoke;
  text-decoration: underline;
}
.darkBread > .breadcrumb {
  background-color: transparent;
}
</style>
